import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const styles = (theme) => ({
  root: {
    display: "flex",
  },
  formControl: {
    margin: theme.spacing(3),
    display: "block",
  },
  group: {
    margin: `${theme.spacing(1)}px 0`,
    flexDirection: "row",
    display: "inline-flex",
    left: 20,
    top: 6,
    position: "relative",
  },
  buttonStyling: {
    textTransform: "inherit",
    fontWeight: "unset",
    padding: "0",
    lineHeight: "unset",
    textDecoration: "underline",
    display: "contents",
  },
});

class ModalButtons extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { buttonTitle, header, dialogBody, classes } = this.props;
    // console.log(closeModal)
    return (
      <React.Fragment>
        <Button
          color="primary"
          className={classes.buttonStyling}
          onClick={this.handleClickOpen}
        >
          {buttonTitle}
        </Button>
        <Dialog
          name={this.state.selectedValue}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{header}</DialogTitle>
          <DialogContent>{dialogBody}</DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ModalButtons);
